"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingServicesList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _static = require("@otpusk/json-api/dist/static");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _price = require("../../../../../../../../helpers/price");
var _Checkbox = _interopRequireDefault(require("../../../../../../../ui/Checkbox"));
var _helpers = require("../../store/helpers");
var _actions = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _luggage = _interopRequireDefault(require("./icons/luggage.svg"));
var _insurance = _interopRequireDefault(require("./icons/insurance.svg"));
var _transfer = _interopRequireDefault(require("./icons/transfer.svg"));
var _excursion = _interopRequireDefault(require("./icons/excursion.svg"));
var _prestige = _interopRequireDefault(require("./icons/prestige.svg"));
var _else = _interopRequireDefault(require("./icons/else.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BookingServicesList = exports.BookingServicesList = function BookingServicesList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, children);
};
BookingServicesList.propTypes = {
  children: _propTypes.default.node.isRequired
};
var bookingIconsByType = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _static.TOUR_OPTIONS.INSURANCE, _insurance.default), _static.TOUR_OPTIONS.LUGGAGE, _luggage.default), _static.TOUR_OPTIONS.TRANSFER, _transfer.default), _static.TOUR_OPTIONS.EXCURSION, _excursion.default), _static.TOUR_OPTIONS.PRESTIGE, _prestige.default), _static.TOUR_OPTIONS.ELSE, _else.default);
var DEFAULT_EMPTY_VALUE = [];
var BookingServicesItem = function BookingServicesItem(_ref2) {
  var currency = _ref2.currency,
    id = _ref2.id,
    name = _ref2.name,
    type = _ref2.type,
    price = _ref2.price,
    countOfPeople = _ref2.countOfPeople,
    _ref2$enabledTourists = _ref2.enabledTourists,
    enabledTourists = _ref2$enabledTourists === void 0 ? [] : _ref2$enabledTourists,
    isGlobalService = _ref2.isGlobalService,
    disabled = _ref2.disabled,
    excludedServices = _ref2.excludedServices;
  var activeService = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getActiveServiceByID)(state, {
      serviceID: id
    });
  });
  var getSelectedTouristsFromExcludedServices = (0, _react.useMemo)(function () {
    return (0, _selectors.makeGetSelectedTouristsFromExcludedServices)();
  }, []);
  var selectedTouristsFromExcludedServices = (0, _reactRedux.useSelector)(function (state) {
    return excludedServices ? getSelectedTouristsFromExcludedServices(state, {
      excludedServices: excludedServices
    }) : DEFAULT_EMPTY_VALUE;
  });
  var indexesOfTourist = (0, _react.useMemo)(function () {
    return (0, _ramda.range)(1, countOfPeople + 1);
  }, [countOfPeople]);
  var activeCountOfService = (0, _react.useMemo)(function () {
    return (0, _helpers.getCountOfService)(Object.keys(activeService).length, isGlobalService);
  }, [activeService, isGlobalService]);
  var dispatch = (0, _reactRedux.useDispatch)();
  var icon = bookingIconsByType[type];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.item
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.info
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: icon
    }
  }), name), price && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.price, _defineProperty({}, _styles.default.defaultPrice, !activeCountOfService))
  }, (0, _price.preparePriceForRender)(Math.max(1, activeCountOfService) * price, currency.symbol))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, (0, _ramda.map)(function (indexOfTourist) {
    var disabledCheckbox = disabled || selectedTouristsFromExcludedServices.includes(indexOfTourist) || !(0, _ramda.isEmpty)(enabledTourists) && !enabledTourists.includes(indexOfTourist);
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      disabled: disabledCheckbox,
      checked: Boolean(activeService[indexOfTourist]),
      onChange: function onChange(checked) {
        if (!isGlobalService) {
          dispatch(checked ? (0, _actions.applyService)(id, indexOfTourist) : (0, _actions.detachService)(id, indexOfTourist));
        } else {
          dispatch(checked ? (0, _actions.setActiveServicesById)(id, enabledTourists) : (0, _actions.detachActiveServicesById)(id));
        }
      },
      key: indexOfTourist
    });
  }, indexesOfTourist)));
};
BookingServicesItem.propTypes = {
  currency: _propTypes.default.shape({
    symbol: _propTypes.default.string.isRequired
  }).isRequired,
  id: _propTypes.default.any.isRequired,
  name: _propTypes.default.string.isRequired,
  countOfPeople: _propTypes.default.number.isRequired,
  isGlobalService: _propTypes.default.bool.isRequired,
  enabledTourists: _propTypes.default.array.isRequired,
  type: _propTypes.default.oneOf([].concat(_toConsumableArray(Object.keys(bookingIconsByType)), [''])),
  price: _propTypes.default.number,
  excludedServices: _propTypes.default.array,
  disabled: _propTypes.default.bool
};
BookingServicesList.Item = (0, _react.memo)(BookingServicesItem);